<template>
  <section class="invoice-preview-wrapper">
    <loader :loading="loading"/>
    <b-alert variant="danger" :show="!userEvaluation && !loading">
      <h4 class="alert-heading">Erreur lors de la récupération des données de la section</h4>
      <div class="alert-body">
        Aucune section trouvée avec cet identifiant. Consultez
        <b-link class="alert-link" :to="{ name: 'section' }">la liste des sections</b-link>
        pour d’autres sections.
      </div>
    </b-alert>
    <div v-if="userEvaluation && canAccessEvaluationPage">
      <b-breadcrumb :items="breadcrumb"/>

      <info-user-evaluation-view
          v-if="!loading && userEvaluation && userData"
          class="mb-3"
          :component-sections="componentSections"
          :user-evaluation="userEvaluation "
          :user-data="userData"
          :current-year="currentYear"
          :is-hierarchy-modifying="isManager"
          :is-between="isBetween"
          :is-after="isAfter"
          :is-rapport="isRapport"
          :is-n2="isN2"
          :is-auto-eval="isAutoEval"
      />

      <b-tabs v-model="activeTab" justified pills>
        <b-card>
          <b-tab title="Auto-évaluation" :active="activeSelfEvaluation" :disabled="isSelfEvaluation">
            <auto-evaluation-form :component-sections="componentSections" :user-evaluation="userEvaluation "
                                  :is-hierarchy-modifying="isManager" :sections="sections"></auto-evaluation-form>
          </b-tab>

          <b-tab title="Évaluation" :active="activeEvaluation" :disabled="isEvaluation">
            <evaluation-form :component-sections="componentSections" :user-evaluation="userEvaluation  "
                             :current-year="currentYear" :sections="sections"></evaluation-form>
          </b-tab>

          <b-tab title="Comparaison" :disabled="isAllEvaluation"
                 :active="activeAllEvaluation">
            <all-evaluation-form :component-sections="componentSections" :user-evaluation="userEvaluation "
                                 :current-year="currentYear" :sections="sections"
                                 :is-hierarchy-modifying="isManager" :is-n2="isN2"></all-evaluation-form>
          </b-tab>
        </b-card>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import {BTabs, BTab, BLink, BAlert,BCard,BBreadcrumb} from 'bootstrap-vue'
import AutoEvaluationForm from "@/views/evaluation/AutoEvaluationForm.vue";
import EvaluationForm from "@/views/evaluation/EvaluationForm.vue";
import AllEvaluationForm from "@/views/evaluation/AllEvaluationForm.vue";
import InfoUserEvaluationView from "@/views/evaluation/InfoUserEvaluationView.vue";
import router from "@/router";
import {getIdUserEvaluations} from "@/services/UserEvaluationService";
import {getJsonFromStorage} from "@/util/storageUtils";
import moment from "moment";
import {getSetting} from "@/services/SettingService";
import {getSectionsByVisibility} from "@/services/SectionService";
import {allSectionComponentModelSectionsByPosition} from "@/services/ComponentModelSectionService";
import {getUserObjectivesByYears} from "@/services/UserObjectiveService";
import Loader from "@/layouts/components/Loader.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import logoSIRAT from "@/assets/images/logo/LOGO_SIRAT_couleur.png";

export default {
  components: {
    Loader, BAlert, BLink,
    BCard,BBreadcrumb,
    InfoUserEvaluationView,
    BTabs,
    AutoEvaluationForm,
    EvaluationForm,
    AllEvaluationForm,
    BTab,
  },
  data() {
    return {
      userEvaluation: null,
      userData: null,
      loadingNew: true,

      isValidated: false,
      comment: '',
      signatureUser: [],
      isRapport: false,
      isSelfEvaluation: true,
      isEvaluation: true,
      isAllEvaluation: true,
      currentYear: null,
      activeSelfEvaluation: false,
      activeEvaluation: false,
      activeAllEvaluation: false,
      isManager: false,
      componentSections: [],
      sections: [],
      loading: true,
      isVerticalMenuCollapsed: this.$store.state.verticalMenu.isVerticalMenuCollapsed,
      activeTab: 0,
      isBetween: false,
      isAfter: false,
      isN2: false,
      isAutoEval:null,
    }
  },

  async created() {

    this.userData = getJsonFromStorage('userData');
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', true)
    await this.fetchUserEvaluationData()

  },
  computed: {
    canAccessEvaluationPage() {
      if (!this.userEvaluation) return false;

      const userData = this.getStoredUserData();

      if (!userData) return false;

      const isOwner = userData.id === this.userEvaluation.users?.id;
      const isManager = this.isManager;
      const isN2 = this.isN2;
      if (this.isRapport) return true;

      return isOwner || isManager || isN2;
    },
    breadcrumb() {
      let parent = {text: 'Profil Utilisateur', to: {name: 'profile'}};

      if (this.isRapport) {
        parent = {text: 'Rapport Evaluation', to: {name: 'evaluation-repport'}};
      } else if (this.isManager) {
        parent = {text: 'Liste Evaluations', to: {name: 'evaluation_list'}};
      }

      const current = {text: 'Récapitulatif'};
      return [parent, current];
    }
  },
  destroyed() {
    this.$store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', this.isVerticalMenuCollapsed)
  },
  watch: {
    activeTab() {
      this.componentSections = []
      this.loading = true

       this.fetchSections()
    }
  },
  methods: {
    getCurrentEvalMode() {
      switch (this.activeTab) {
        case 0:
          return false      // Auto-évaluation
        case 1:
          return true       // Évaluation
        case 2:
          return null       // Comparatif
        default:
          return false
      }
    },

    async getSettings() {
      const response = await getSetting();

      if (response && response.yearEvaluation) {

        this.currentYear = response?.yearEvaluation?.year;

      }

    },
    getStoredUserData() {
      const storedUserData = getJsonFromStorage('userData')
      return storedUserData ? storedUserData : null
    },
    async fetchUserEvaluationData() {
      const userEvaluationId = router.currentRoute.params.id;
      const rapport =Number(this.$route.params.isRapport);

      this.isRapport = rapport === 1;
      const user = this.getStoredUserData();
      if (userEvaluationId) {
        try {
          this.userEvaluation = await getIdUserEvaluations(userEvaluationId, user.id);
          this.currentYear = this.userEvaluation?.years;
          this.isHierarchyModifying()
          this.isHierarchyN2()

          if (!this.canAccessEvaluationPage) {
            if (this.$route.name !== 'profile') {
              await this.$router.replace({name: 'profile'});
            }
            return;

          }
          if (this.isRapport) {
            const isOwner = this.userData?.id === this.userEvaluation?.users?.id
            if (this.isManager || isOwner) {
              this.isRapport = false
            }
          }
          this.computeTabsAccess(this.userEvaluation);

          this.comment = this.userEvaluation.description
          this.isValidated = this.userEvaluation.valid
          console.log(this.userEvaluation)

          await this.fetchSections();

        } catch (error) {
          console.error('Error fetching userObjective data:', error);
        } finally {

        }
      } else {
        console.error('No UserEvaluation ID found in route params.');

      }

    },
    isHierarchyModifying() {


      if (this.userEvaluation && this.userEvaluation.evaluationSignature) {
        const userEvaluationSignature = this.userEvaluation.evaluationSignature.find(sigObj => sigObj.users.id === this.userData.id);
        this.isManager= userEvaluationSignature && userEvaluationSignature.hierarchyN ===1;
      }
    },
    isHierarchyN2() {

      if (this.userEvaluation && this.userEvaluation.evaluationSignature) {
        const userEvaluationSignature = this.userEvaluation.evaluationSignature.find(sigObj => sigObj.users.id === this.userData.id);
        this.isN2 =userEvaluationSignature && userEvaluationSignature.hierarchyN === 2;
      }
    },


    computeTabsAccess(data) {


      if (data.dateEvaluationPrevu) {
        const datePlan = moment(data.dateEvaluationPrevu, 'DD-MM-YYYY HH:mm', true)
        const datePlanSubstract =
            this.getEvaluationDateWithHourSubstracted(data.dateEvaluationPrevu)

        this.isBetween = moment().isBetween(datePlanSubstract, datePlan)
        this.isAfter = moment().isAfter(datePlan)

        if (this.isBetween || this.isAfter) {
          this.isSelfEvaluation = false
          this.isEvaluation = false
          this.isAllEvaluation = false
          this.activeAllEvaluation = true
          return
        }
      }
      if (this.isRapport) {

        this.isSelfEvaluation = false
        this.isEvaluation = false
        this.isAllEvaluation = false
        this.activeAllEvaluation = true


      } else if (this.isManager) {

        this.isEvaluation = false
        this.isAllEvaluation = true
        this.isSelfEvaluation = true
        this.activeEvaluation = true

      } else {
        this.isSelfEvaluation = false
        this.isEvaluation = true
        this.isAllEvaluation = true
        this.activeSelfEvaluation = true
      }

    },


    getEvaluationDateWithHourSubstracted(date) {
      if (!date) {
        this.showToast('La date de validation est manquante', 'danger');
        return;
      }

      const currentDate = moment(date, "DD-MM-YYYY HH:mm", true);

      return currentDate.subtract(36, 'hours');
    },

    showToast(message,color) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: "CheckCircleIcon",
          variant: color,
        },
      });
    },
    isStandard(sectionId) {
      const sectionData = this.sections.find(section => section.position === sectionId);
      return sectionData && sectionData.responseChoice === 'Standard';
    },
    async fetchSections() {

      try {
        this.sections = await getSectionsByVisibility(true);

        this.componentSections = await Promise.all(
            this.sections.map(async section => {
              try {
                const content = (await allSectionComponentModelSectionsByPosition(section.position)) || [];

                await this.updateObjective();

                for (const cont of content) {
                  // Si la section a un objectif utilisateur
                  if (cont.objectif && this.userObjective?.objectifs) {
                    section.coef = this.userObjective.note;
                    const objectives = this.userObjective.objectifs.sort((a, b) => a.idObjective - b.idObjective);

                    cont.componentModels = objectives.map(objective => ({
                      titre: objective.objectif,
                      objective: true,
                      idPublic: objective.id,
                      note: objective.note,
                    }));
                  }

                  if (cont.contentSections && cont.componentModels) {
                    for (const contentSection of cont.contentSections) {
                      // Détermine le type de réponse à récupérer
                       this.isAutoEval = this.getCurrentEvalMode();

                      if (cont.componentModels.length > 0) {
                        for (const componentModel of cont.componentModels) {
                          let valueComponentModel = this.getComponentModel(componentModel, contentSection, section, this.isAutoEval);

                          if (this.isAutoEval === null && valueComponentModel) {
                            valueComponentModel = {
                              auto: valueComponentModel.auto,
                              eval: valueComponentModel.eval
                            };
                          }

                          componentModel.valueComponentModels = componentModel.valueComponentModels || [];
                          componentModel.valueComponentModels.push(valueComponentModel);
                        }
                      } else {
                        let valueComponentModel = this.getComponentModel(null, contentSection, section, this.isAutoEval);

                        if (this.isAutoEval === null && valueComponentModel) {
                          valueComponentModel = {
                            auto: valueComponentModel.auto,
                            eval: valueComponentModel.eval
                          };
                        }

                        contentSection.valueComponentModels = contentSection.valueComponentModels || [];
                        contentSection.valueComponentModels.push(valueComponentModel);
                      }
                    }
                  }
                }

                return {section, content};
              } catch (err) {
                console.error("Erreur dans le traitement de la section :", section, err);
                return null; // Skip section si erreur
              }
            })
        );

        // Supprime les sections null
        this.componentSections = this.componentSections.filter(Boolean);

        // Gestion des coefficients
        const sectionsAvecCoef = this.componentSections
            .map(item => item?.section)
            .filter(section => section && section.requiredCalcul);

        const sectionAvecCoefFixe = sectionsAvecCoef.find(section => section.coef != null);
        const autresSections = sectionsAvecCoef.filter(section => section !== sectionAvecCoefFixe);

        if (sectionAvecCoefFixe && autresSections.length > 0) {
          const reste = 100 - sectionAvecCoefFixe.coef;
          const repartition = reste / autresSections.length;
          autresSections.forEach(section => {
            section.coef = repartition;
          });
        }

        const getIdPublic = v => (v ? (typeof v === 'object' ? (v.idPublic ?? v.id ?? null) : v) : null);

        const sectionCoefMap = new Map();
        this.componentSections.forEach(sObj => {
          const sid = getIdPublic(sObj?.section?.idPublic);
          if (sid != null && typeof sObj.section.coef !== 'undefined') {
            sectionCoefMap.set(sid, sObj.section.coef);
          }
        });
        this.loading = false;

      } catch (error) {
        console.error("Erreur lors de la récupération des sections:", error);
        this.loading = false;

      }
    },
    async updateObjective() {
      this.userObjective = await getUserObjectivesByYears(this.userEvaluation.users.id, this.currentYear);
    },
    getComponentModel(componentsTable, component, section, isAutoEval) {
      if (isAutoEval === null || isAutoEval === undefined) {

        const autoEvalResponse = this.findResponse(componentsTable, component, section, false);
        const evalResponse = this.findResponse(componentsTable, component, section, true);

        const formatValue = (response) => {
          if (!response) return null;
          const type = component.champsModel?.typeReponse;
          switch (type) {
            case 'string':
              return response.answerString || '';
            case 'date':
              return response.answerDate || null;
            case 'integer':
              return response.answerInteger ?? 0;
            case 'double':
              return response.answerDouble ?? 0;
            case 'boolean':
              return response.answerBoolean ?? false;
            case 'list':
              return response.answerList || response.answerString || [];
            default:
              return null;
          }
        };

        return {
          auto: formatValue(autoEvalResponse),
          eval: formatValue(evalResponse)
        };

      } else {
        const foundResponse = this.findResponse(componentsTable, component, section, isAutoEval);
        if (!foundResponse) return null;
        const type = component?.champsModel?.typeReponse;
        switch (type) {
          case 'string':
            return foundResponse.answerString || '';
          case 'date':
            return foundResponse.answerDate || null;
          case 'integer':
            return foundResponse.answerInteger || 0;
          case 'double':
            return foundResponse.answerDouble || 0;
          case 'boolean':
            return foundResponse.answerBoolean || false;
          case 'list':
            return foundResponse.answerList || foundResponse.answerString || [];
          default:
            return null;
        }
      }


    },

    findResponse(componentsTable, component, section, isAutoEval) {
      // const matchingSignature = this.userEvaluation?.evaluationSignature?.[0];
      const matchingSignature = this.userEvaluation?.evaluationSignature?.find(
          signature => signature?.hierarchyN === 1
      );
      const responsesList = isAutoEval
          ? (matchingSignature?.reponses || [])
          : (this.userEvaluation?.reponses || []);

      return responsesList.find(response => {
        const hasContentSection = response?.contentSection?.idPublic === component?.idPublic;

        if (componentsTable?.idPublic && !this.isStandard(section)) {
          return hasContentSection && (
              (response.componentModel?.idPublic === componentsTable.idPublic) ||
              (response.objective?.id === componentsTable.idPublic)
          );
        }
        return hasContentSection;
      });
    },




  },
  mounted() {
     this.getSettings();

    this.fetchUserEvaluationData();


  },
}
</script>

<style>
ul.nav-pills li.nav-item {
  background-color: #fff;
}
</style>